/* eslint-disable global-require */
import React from 'react';
import { compose } from 'redux';
import { Route, Redirect, IndexRoute } from 'react-router';
import App from './modules/App/App';

// Import higher order components
import RequireSubscription from './components/RequireSubscription';
import SubscriptionValidation from './components/SubscriptionValidation';
import RequireDashboards from './components/RequireDashboards';
import RequireAuth from './components/RequireAuth';
import ErrorBoundary from './components/ErrorBoundary';
import CheckPartner from './components/CheckPartner';
import RequireManageUsers from './components/RequireManageUsers';
import RequireManageBilling from './components/RequireManageBilling';
import RequireCreateDashboards from './components/RequireCreateDashboards';
import RequireDashboardAccess from './components/RequireDashboardAccess';
import RequireActivePremium from './components/RequireActivePremium';
import RequirePremiumOff from './components/RequirePremiumOff';
import RequireAkb from './components/RequireAkb';
import RequireFileApp from './components/RequireFileApp';

//Import pages
//auth pages
import Login from './modules/Auth/pages/LoginPage';
import Register from './modules/Auth/pages/RegisterPage';
import SelectHost from './modules/Auth/pages/SelectHostPage';
import Forgot from './modules/Auth/pages/ForgotPage';
import Reset from './modules/Auth/pages/ResetPage';
import Complete from './modules/Auth/pages/CompletePage/CompletePage';
import NotFound from './modules/Common/pages/NotFoundPage';
import GeneralError from './modules/Common/pages/GeneralError';
import AuthGeneralError from './modules/Common/pages/AuthGeneralError';
import GenericMessagePage from './modules/Common/pages/GenericMessagePage';
import Downtime from './modules/Common/pages/Downtime';
import WelcomePage from './modules/Common/pages/WelcomePage';
import ErrorPage from './modules/Common/pages/ErrorPage';
import AwaitingPage from './modules/Common/pages/AwaitingPage';
import TrialPage from './modules/Common/pages/TrialPage';
import AkbPage from './modules/Common/pages/AkbPage';
import ChatPage from './modules/Common/pages/ChatPage';
import NaveAddonPage from './modules/Common/pages/NaveAddonPage';

import CreateDashboard from './modules/CreateDashboard/CreateDashboard';
import Users from './modules/Users/Users';
import Dashboards from './modules/Dashboards/Dashboards';
import Permissions from './modules/Permissions/Permissions';
import Terms from './modules/Terms/pages/Terms';
import Wallboard from './modules/Wallboard/Wallboard';
import Wallboards from './modules/Wallboards/Wallboards';
import Overview from './modules/Overview/pages/Overview';
import ProcessImprovement from './modules/ProcessImprovement/pages/ProcessImprovement';
import CFD from './modules/CFD/pages/CFD';
import CTSP from './modules/CycleTimeScatterPlot/pages/CTSP';
import CTB from './modules/CycleTimeBreakdown/pages/CTB';
import CTH from './modules/CycleTimeHistogram/pages/CTH';
import CTA from './modules/CycleTimeAging/pages/CTA';
import Throughput from './modules/Throughput/pages/Throughput';
import ThroughputHistogram from './modules/ThroughputHistogram/pages/ThroughputHistogram';
import FlowEfficiency from './modules/FlowEfficiency/pages/FlowEfficiency';
import DueDatePerf from './modules/DueDatePerformance/pages/DueDatePerformance';
import MonteCarloDates from './modules/MonteCarlo/pages/MonteCarloDates';
import MonteCarloTasks from './modules/MonteCarloTasks/pages/MonteCarloTasks';
import Subscribe from './modules/Subscribe/pages/Subscribe';
import Upgrade from './modules/Subscribe/pages/Upgrade';
import DigitalUpgrade from './modules/DigitalProgram/pages/DigitalUpgrade';
import Billing from './modules/Billing/pages/Billing';
import LimitReached from './modules/Common/pages/LimitReached';
import RemoveDashboards from './modules/Common/pages/RemoveDashboards';
import Reports from './modules/ReportConfig/Reports';
import ReportConfig from './modules/ReportConfig/ReportConfig';
import Portfolios from './modules/Portfolios/Portfolios';
import PortfolioConfig from './modules/Portfolios/PortfolioConfig';
import AllForecasts from './modules/Forecasting/pages/AllForecasts';
import ForecastingDashboard from './modules/Forecasting/pages/ForecastingDashboard';

import SsoConfig from './modules/Sso/pages/SsoConfig';

// require.ensure polyfill for node
if (typeof require.ensure !== 'function') {
  require.ensure = function requireModule(deps, callback) {
    callback(require);
  };
}

/* Workaround for async react routes to work with react-hot-reloader till
  https://github.com/reactjs/react-router/issues/2182 and
  https://github.com/gaearon/react-hot-loader/issues/288 is fixed.
 */
if (process.env.RUN_ENV === 'development') {
  // Require async routes only in development for react-hot-reloader to work.
  require('./modules/App/App');
  require('./modules/Common/pages/NotFoundPage');
  require('./modules/Common/pages/GeneralError');
  require('./modules/Common/pages/AuthGeneralError');
  require('./modules/Common/pages/Downtime');
  require('./modules/Common/pages/LimitReached');
  require('./modules/Common/pages/RemoveDashboards');
  require('./modules/Common/pages/WelcomePage');
  require('./modules/Common/pages/ErrorPage');
  require('./modules/Common/pages/AwaitingPage');
  require('./modules/Common/pages/TrialPage');
  require('./modules/Common/pages/AkbPage');
  require('./modules/Common/pages/ChatPage');
  require('./modules/Common/pages/NaveAddonPage');
  require('./modules/Auth/pages/LoginPage');
  require('./modules/Auth/pages/RegisterPage');
  require('./modules/Auth/pages/SelectHostPage');
  require('./modules/Auth/pages/ForgotPage');
  require('./modules/Auth/pages/ResetPage');
  require('./modules/Auth/pages/CompletePage/CompletePage');
  require('./modules/CreateDashboard/CreateDashboard');
  require('./modules/Terms/pages/Terms');
  require('./modules/Users/Users');
  require('./modules/Dashboards/Dashboards');
  require('./modules/Permissions/Permissions');
  require('./modules/Wallboard/Wallboard');
  require('./modules/Wallboards/Wallboards');
  require('./modules/Forecasting/pages/AllForecasts');
  require('./modules/Forecasting/pages/ForecastingDashboard');

  require('./modules/Overview/pages/Overview');
  require('./modules/ProcessImprovement/pages/ProcessImprovement');
  require('./modules/CFD/pages/CFD');
  require('./modules/CycleTimeScatterPlot/pages/CTSP');
  require('./modules/CycleTimeBreakdown/pages/CTB');
  require('./modules/CycleTimeHistogram/pages/CTH');
  require('./modules/CycleTimeAging/pages/CTA');
  require('./modules/Throughput/pages/Throughput');
  require('./modules/ThroughputHistogram/pages/ThroughputHistogram');
  require('./modules/FlowEfficiency/pages/FlowEfficiency');
  require('./modules/DueDatePerformance/pages/DueDatePerformance');
  require('./modules/MonteCarlo/pages/MonteCarloDates');
  require('./modules/MonteCarloTasks/pages/MonteCarloTasks');
  require('./modules/Subscribe/pages/Subscribe');
  require('./modules/Subscribe/pages/Upgrade');
  require('./modules/DigitalProgram/pages/DigitalUpgrade');
  require('./modules/Billing/pages/Billing');
  require('./modules/ReportConfig/Reports');
  require('./modules/ReportConfig/ReportConfig');

  require('./modules/Sso/pages/SsoConfig');
}

// react-router setup with code-splitting
// More info: http://blog.mxstbr.com/2016/01/react-apps-with-pages/
export default (
  <Route path="/" component={ErrorBoundary(App)}>
    <IndexRoute component={compose(RequireSubscription, RequireDashboards, RequireAuth)(Overview)} />
    <Route path="sso/config" component={compose(RequireAuth, RequireManageUsers, RequireFileApp)(SsoConfig)} />
    <Route path="login" component={Login} />
    <Route path="sso/login/:accountId" component={Login} />
    <Route path="register" component={Register} />
    <Route path="hosts" component={SelectHost} />
    <Route path="forgotpassword" component={Forgot} />
    <Route path="reset/:token" component={Reset} />
    <Route path="setup" component={Complete} />
    <Route path="terms" component={Terms} />
    <Route path="welcome" component={WelcomePage} />
    <Route path="error" component={ErrorPage} />
    <Route path="addon" component={NaveAddonPage} />
    <Route path="awaiting" component={compose(RequireAuth)(AwaitingPage)} />
    <Route path="awaiting/sso" component={compose(RequireAuth)(AwaitingPage)} />
    <Route path="akb" component={compose(RequireAuth, RequireAkb)(AkbPage)} />
    <Route path="chat" component={compose(RequireAuth)(ChatPage)} />
    <Route path="users" component={compose(RequireAuth, RequireManageUsers)(Users)} />
    <Route
      path="dashboards(/:id)"
      component={compose(RequireAuth, RequireManageUsers, RequireDashboardAccess)(Dashboards)}
    />
    <Route path="free" component={compose(RequireAuth, RequireDashboards)(RemoveDashboards)} />
    <Route
      path="permissions/:id"
      component={compose(RequireAuth, RequireManageUsers, RequireDashboardAccess)(Permissions)}
    />
    <Route path="subscribe" component={compose(RequireAuth, RequireManageBilling, CheckPartner)(Subscribe)} />
    <Route path="upgrade" component={compose(RequireAuth, RequireManageBilling, CheckPartner)(Upgrade)} />
    <Route path="digital" component={compose(RequireAuth, RequireManageBilling, CheckPartner)(DigitalUpgrade)} />
    <Route path="billing" component={compose(RequireAuth, RequireManageBilling, CheckPartner)(Billing)} />
    <Route path="wallboard/:id" component={compose(RequireSubscription, RequireDashboards, RequireAuth)(Wallboard)} />
    <Route path="settings/:id" component={compose(RequireSubscription, RequireDashboards, RequireAuth)(Wallboards)} />
    <Route
      path="forecasts/:dashboardId"
      component={compose(RequireActivePremium, RequireDashboards, RequireAuth)(AllForecasts)}
    />
    <Route
      path="/dashboard/:dashboardId/forecasts"
      component={compose(RequireActivePremium, RequireDashboards, RequireAuth)(AllForecasts)}
    />
    <Route
      path="forecasting/:dashboardId/:id"
      component={compose(RequireActivePremium, RequireDashboards, RequireAuth)(ForecastingDashboard)}
    />
    <Route path="report(/:id)" component={compose(RequireActivePremium, RequireDashboards, RequireAuth)(Reports)} />
    <Route path="portfolios(/:id)" component={compose(RequireActivePremium, RequireAuth)(Portfolios)} />
    <Route
      path="portfolio(/:id)"
      component={compose(RequireActivePremium, RequireDashboards, RequireAuth)(PortfolioConfig)}
    />
    <Route
      path="configure(/:id)"
      component={compose(RequireActivePremium, RequireDashboards, RequireAuth)(ReportConfig)}
    />
    <Route path="premium" component={compose(RequirePremiumOff, RequireDashboards, RequireAuth)(TrialPage)} />
    <Route path="expired" component={GenericMessagePage} />
    <Route path="cancelled" component={GenericMessagePage} />
    <Route path="unlicensed" component={GenericMessagePage} />
    <Route path="no-dashboards" component={GenericMessagePage} />
    <Route path="no-streams" component={GenericMessagePage} />
    <Route path="no-portfolios" component={GenericMessagePage} />
    <Route path="no-enough-streams" component={GenericMessagePage} />
    <Route path="no-create-dashboard-permissions" component={GenericMessagePage} />
    <Route path="no-value-stream-permissions" component={GenericMessagePage}/>
    <Route path="404" component={NotFound} />
    <Route path="401" component={AuthGeneralError} />
    <Route path="500" component={GeneralError} />
    <Route path="downtime" component={Downtime} />
    <Route path="limitreached" component={LimitReached} />
    <Route
      path="create"
      component={compose(
        RequireSubscription,
        RequireAuth,
        SubscriptionValidation,
        RequireCreateDashboards
      )(CreateDashboard)}
    />
    <Route path="update/:id" component={compose(RequireSubscription, RequireAuth)(CreateDashboard)} />
    <Route
      path="/dashboard/:dashboardId"
      component={compose(RequireSubscription, RequireDashboards, RequireAuth)(Overview)}
    />
    <Route
      path="/dashboard/:dashboardId/process"
      component={compose(RequireSubscription, RequireDashboards, RequireAuth)(ProcessImprovement)}
    />
    <Route path="/cfd" component={compose(RequireDashboards, RequireAuth)(CFD)} />
    <Route path="/dashboard/:dashboardId/cfd" component={compose(RequireDashboards, RequireAuth)(CFD)} />
    <Route path="/ctsp" component={compose(RequireSubscription, RequireDashboards, RequireAuth)(CTSP)} />
    <Route
      path="/dashboard/:dashboardId/ctsp"
      component={compose(RequireSubscription, RequireDashboards, RequireAuth)(CTSP)}
    />
    <Route path="/ctb" component={compose(RequireSubscription, RequireDashboards, RequireAuth)(CTB)} />
    <Route
      path="/dashboard/:dashboardId/ctb"
      component={compose(RequireSubscription, RequireDashboards, RequireAuth)(CTB)}
    />
    <Route path="/cth" component={compose(RequireSubscription, RequireDashboards, RequireAuth)(CTH)} />
    <Route
      path="/dashboard/:dashboardId/cth"
      component={compose(RequireSubscription, RequireDashboards, RequireAuth)(CTH)}
    />
    <Route path="/cta" component={compose(RequireSubscription, RequireDashboards, RequireAuth)(CTA)} />
    <Route
      path="/dashboard/:dashboardId/cta"
      component={compose(RequireSubscription, RequireDashboards, RequireAuth)(CTA)}
    />
    <Route path="/trc" component={compose(RequireSubscription, RequireDashboards, RequireAuth)(Throughput)} />
    <Route
      path="/dashboard/:dashboardId/trc"
      component={compose(RequireSubscription, RequireDashboards, RequireAuth)(Throughput)}
    />
    <Route path="/th" component={compose(RequireSubscription, RequireDashboards, RequireAuth)(ThroughputHistogram)} />
    <Route
      path="/dashboard/:dashboardId/th"
      component={compose(RequireSubscription, RequireDashboards, RequireAuth)(ThroughputHistogram)}
    />
    <Route path="/fe" component={compose(RequireSubscription, RequireDashboards, RequireAuth)(FlowEfficiency)} />
    <Route
      path="/dashboard/:dashboardId/fe"
      component={compose(RequireSubscription, RequireDashboards, RequireAuth)(FlowEfficiency)}
    />
    <Route path="/ddp" component={compose(RequireSubscription, RequireDashboards, RequireAuth)(DueDatePerf)} />
    <Route
      path="/dashboard/:dashboardId/ddp"
      component={compose(RequireSubscription, RequireDashboards, RequireAuth)(DueDatePerf)}
    />
    <Route
      path="/montecarlodates"
      component={compose(RequireSubscription, RequireDashboards, RequireAuth)(MonteCarloDates)}
    />
    <Route
      path="/dashboard/:dashboardId/montecarlodates"
      component={compose(RequireSubscription, RequireDashboards, RequireAuth)(MonteCarloDates)}
    />
    <Route
      path="/montecarlotasks"
      component={compose(RequireSubscription, RequireDashboards, RequireAuth)(MonteCarloTasks)}
    />
    <Route
      path="/dashboard/:dashboardId/montecarlotasks"
      component={compose(RequireSubscription, RequireDashboards, RequireAuth)(MonteCarloTasks)}
    />
    <Redirect from="*" to="/404" />
  </Route>
);
